import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-337ae690"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "main-page"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_app_alert = _resolveComponent("app-alert");
  const _component_pdf_renderer = _resolveComponent("pdf-renderer");
  const _component_the_sidebar = _resolveComponent("the-sidebar");
  const _component_app_icon = _resolveComponent("app-icon");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_app_alert), _createVNode(_component_pdf_renderer), _createElementVNode("div", {
    style: _normalizeStyle($options.homepageStyle),
    class: "homepage-wrapper",
    onClick: _cache[1] || (_cache[1] = (...args) => $options.handleClickOutside && $options.handleClickOutside(...args))
  }, [_createVNode(_component_the_sidebar, {
    isCollapsed: $data.isCollapsed,
    onHandleCollapse: $options.handleCollapse,
    onHandleMouseEnter: $options.handleHoveringOn,
    onHandleMouseLeave: $options.handleHoveringOff,
    onHandleProfileSettingsClick: $options.handleProfileSettingsClick,
    onCloseProfileSettingsPanel: $options.closeProfileSettingsPanel,
    onHandleTopAccountBtnClicked: $options.handleTopAccountBtnClicked,
    isProfileSettingsShown: $data.isProfileSettingsShown,
    showTopAccountListView: $data.showTopAccountListView,
    isHovering: $data.isHovering,
    style: _normalizeStyle({
      width: 'var(--wrapper-private-sidebar-width)'
    })
  }, null, 8, ["isCollapsed", "onHandleCollapse", "onHandleMouseEnter", "onHandleMouseLeave", "onHandleProfileSettingsClick", "onCloseProfileSettingsPanel", "onHandleTopAccountBtnClicked", "isProfileSettingsShown", "showTopAccountListView", "isHovering", "style"]), _createElementVNode("div", _hoisted_1, [_renderSlot(_ctx.$slots, "default", {}, undefined, true)]), $data.isCollapsed && !$data.isHovering ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "icon-container expand-icon",
    onClick: _cache[0] || (_cache[0] = () => $options.handleCollapse(false))
  }, [_createVNode(_component_app_icon, {
    icon: "sidebar-expand",
    color: "var(--market-1000)"
  })])) : _createCommentVNode("", true)], 4)], 64);
}